import { BaseDecimal, Chain, SwapKitNumber } from "@swapkit/core";

export const MARKETPLACE_FEE = 0.025;
export const MAX_LISTING_PRICE = 100_000_000; // 100 million RUNE
export const MIN_LISTING_PRICE = 0.08; // 0.08 RUNE

export const decimal = BaseDecimal[Chain.THORChain];

export const transferProfitToForgeNetworkFee = new SwapKitNumber({ value: 0.02, decimal });
export const transferProfitToSellerNetworkFee = new SwapKitNumber({ value: 0.020001, decimal });
export const transferTNSToBuyerNetworkFee = new SwapKitNumber({ value: 0.02, decimal });
